var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"iframe",attrs:{"id":"show-iframe","scrolling":"auto","width":"100%","height":"100%","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }